import React from "react";
import { Routes, Route } from "react-router-dom";
import Splash from "../pages/Authentication/Splash";
import Login from "../pages/Authentication/Login";
import OtpVerification from "../pages/Authentication/OtpVerification";
import ProfileSetup from "../pages/Authentication/ProfileSetup";
function UnAuthenticatedRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Splash />} />
      <Route path="/login" element={<Login />} />
      <Route path="/otp-verification" element={<OtpVerification />} />
      <Route path="/profile-setup" element={<ProfileSetup />} />
    </Routes>
  );
}

export default UnAuthenticatedRoutes;
